import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@karma/components';
import debounce from 'lodash/debounce';
import useClientDimensions from 'hooks/useClientDimensions';

const InfiniteScroll = ({ children, fetchMore, isFetching, left, ...props }) => {
  const [scrollableElement, setScrollableElement] = useState();
  const { clientHeight } = useClientDimensions();

  const onLoadMore = useCallback(() => {
    if (!isFetching && left) {
      fetchMore();
    }
  }, [fetchMore, isFetching, left]);

  useEffect(() => {
    const onScrollFetchMore = debounce(() => {
      if (scrollableElement) {
        const bounding = scrollableElement.getBoundingClientRect();
        const { bottom: elementBottom } = bounding;

        if (elementBottom < clientHeight) {
          onLoadMore();
        }
      }
    }, 100);

    window.addEventListener('scroll', onScrollFetchMore, { passive: false });

    return () => {
      window.removeEventListener('scroll', onScrollFetchMore, { passive: false });
    };
  }, [clientHeight, onLoadMore, scrollableElement]);

  return (
    <Stack ref={setScrollableElement} {...props}>
      {children}
    </Stack>
  );
};

InfiniteScroll.propTypes = {
  children: PropTypes.node.isRequired,
  fetchMore: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  left: PropTypes.bool.isRequired,
};

export default InfiniteScroll;
